import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useOperationStore } from "@/stores/operation";
import NoticeView from "@/components/NoticeFormView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateView',
  props: {
  status: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const operationStore = useOperationStore();
const server = process.env.VUE_APP_ROOT_API ?? "https://api-gabarit.promo.dev";
const loading = ref<boolean>(false);
const hiderror = ref<boolean>(true);
const relay = ref<object>({});
const message = ref<string>("");
const sendedToApi = ref(false);
const reactivity = ref(true);

// eslint-disable-next-line no-undef


const notice = ref(false);
const filteredForms = (lang: string | undefined) => {
  if (Array.isArray(operationStore.operationData?.forms)) {
    const form = operationStore.operationData?.forms?.filter((form) => {
      return form.type == "CREATE" && form.lang == lang && !form.line_item;
    });

    if (!form || form.length === 0) {
      message.value = "FormId not found";
      return [];
    }
    return form[0]._id;
  }
  return [];
};

const getResult = (result: Array<unknown>) => {
  loading.value = false;

  if (result) {
    sendedToApi.value = true;
    // setTimeout(() => {
    //   sendedToApi.value = false;
    // }, 10000);
  }
};

const onLoading = () => {
  loading.value = true;
};

const showErrorForm = (event?: {
  error: string[] | { message: string };
  errorId: string;
}) => {
  if (!event) {
    return;
  }
  if (
    event.error &&
    Array.isArray(event.error) &&
    event.error.length > 0 &&
    (event.error[0] == "Email domain not allowed" ||
      event.error[0] == "Email address with + character not allowed")
  ) {
    alert(
      "L'adresse email que vous avez saisie n'est pas autorisée ou invalide. Veuillez utiliser une adresse email valide."
    );
    return;
  }
  loading.value = false;
  // message.value = showError(event) as string;
  return message.value;
};

const formId = ref(filteredForms("fr"));

//import { defineEmits } from "vue";
//const emit = defineEmits(["direction", "update"]);

//const bannerDirection = () => {
//  emit("direction", "right");
//};
//const fullOpen = () => {
//  emit("direction", "fullopen");
//};

const checkRgpd = () => {
  setTimeout(() => {
    const noticelink = document.querySelector("#noticelink");
    if (noticelink) {
      noticelink.addEventListener("click", (event) => {
        event.preventDefault();
        notice.value = true;
      });
    }
  }, 1000);
};

onMounted(() => {
  checkRgpd();
});

const closeNotice = () => {
  notice.value = false;
  checkRgpd();
};

return { __sfc: true,operationStore, server, loading, hiderror, relay, message, sendedToApi, reactivity, props, notice, filteredForms, getResult, onLoading, showErrorForm, formId, checkRgpd, closeNotice, NoticeView }
}

})